import { createSlice } from "@reduxjs/toolkit";
import { ConfiguracaoImpostoAdicionalModel } from "../../../models/configuracaoImpostoAdicional/configuracaoImpostoAdicionalModel";
import { listarConfiguracaoImpostoAdicional } from "../../../services/configuracaoImpostoAdicionalService";
import { resetAll } from "../../actions/actions";
import { BuscaConfiguracaoImpostoAdicionalModel } from "../../../models/configuracaoImpostoAdicional/buscaConfiguracaoImpostoAdicionalModel";
import dayjs from "dayjs";

dayjs.locale("pt-br");
export interface ConfiguracaoImpostoAdicionalState {
  //buscar configuracao imposto adicional
  loading: boolean;
  busca: BuscaConfiguracaoImpostoAdicionalModel;
  list: ConfiguracaoImpostoAdicionalModel[];
  entity: ConfiguracaoImpostoAdicionalModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: ConfiguracaoImpostoAdicionalState = {
  //buscar configuracao imposto adicional
  loading: false,
  busca: {
    idEmpresa: null,
    dataInicio: dayjs().startOf("month").toDate(),
    dataFim: dayjs().endOf("month").toDate(),
  } as BuscaConfiguracaoImpostoAdicionalModel,
  list: [],
  entity: {} as ConfiguracaoImpostoAdicionalModel,
  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const configuracaoImpostoAdicionalSlice = createSlice({
  name: "configuracaoImpostoAdicional",
  initialState,
  reducers: {
    //buscar configuracao imposto adicional
    setBuscaConfiguracaoImpostoAdicional: (state, action) => {
      state.busca = action.payload;
    },
    setEntityConfiguracaoImpostoAdicional: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarConfiguracaoImpostoAdicional: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarConfiguracaoImpostoAdicional: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar configuracao imposto adicional
    builder.addCase(listarConfiguracaoImpostoAdicional.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(listarConfiguracaoImpostoAdicional.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(listarConfiguracaoImpostoAdicional.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar configuracao imposto adicional
  setBuscaConfiguracaoImpostoAdicional,
  setEntityConfiguracaoImpostoAdicional,
  //internal
  setModalCadastrarConfiguracaoImpostoAdicional,
  setModalDeletarConfiguracaoImpostoAdicional,
} = configuracaoImpostoAdicionalSlice.actions;

export default configuracaoImpostoAdicionalSlice.reducer;
